import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  getJobPosts as getJobPostsApi,
  getJobPostsStats as getJobPostsStatsApi,
  addNewJobPost as addNewJobPostApi,
  updateJobPost as updateJobPostApi,
  updateJobPostStatus as updateJobPostStatusApi,
  deleteJobPost as deleteJobPostApi,
} from "../../helpers/realbackend_helper";

export const getJobPosts = createAsyncThunk(
  "jobposts/getJobPosts",
  async (params, { rejectWithValue }) => {
    try {
      const response = await getJobPostsApi(params);
      return response;
    } catch (error) {
      return rejectWithValue(error.response || error.message);
    }
  }
);

export const getJobPostsStats = createAsyncThunk(
  "jobposts/getJobPostsStats",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getJobPostsStatsApi();
      return response;
    } catch (error) {
      return rejectWithValue(error.response || error.message);
    }
  }
);

export const addNewJobPost = createAsyncThunk(
  "jobposts/addNewJobPost",
  async (data, { rejectWithValue }) => {
    try {
      const response = await addNewJobPostApi(data);
      toast.success("Ажлын зар амжилттай нэмэгдлээ", { autoClose: 3000 });
      return response;
    } catch (error) {
      toast.error("Ажлын зар нэмэхэд алдаа гарлаа!", { autoClose: 3000 });
      return rejectWithValue(error.response || error.message);
    }
  }
);

export const updateJobPost = createAsyncThunk(
  "jobposts/updateJobPost",
  async (data, { rejectWithValue }) => {
    try {
      const response = await updateJobPostApi(data);
      toast.success("Мэдээллийг амжилттай засварлалаа", { autoClose: 3000 });
      return response;
    } catch (error) {
      toast.error("Засварлахад алдаа гарлаа!", { autoClose: 3000 });
      return rejectWithValue(error.response || error.message);
    }
  }
);

export const updateJobPostStatus = createAsyncThunk(
  "jobposts/updateJobPostStatus",
  async ({ id, statusData }, { rejectWithValue }) => {
    try {
      const response = await updateJobPostStatusApi(id, statusData);
      toast.success("Төлөв амжилттай өөрчлөгдлөө", { autoClose: 3000 });
      return response;
    } catch (error) {
      toast.error("Төлөв өөрчлөхөд алдаа гарлаа!", { autoClose: 3000 });
      return rejectWithValue(error.response || error.message);
    }
  }
);

export const deleteJobPost = createAsyncThunk(
  "jobposts/deleteJobPost",
  async (id, { rejectWithValue }) => {
    try {
      await deleteJobPostApi(id);
      toast.success("Ажлын зар устгагдлаа", { autoClose: 3000 });
      return { id };
    } catch (error) {
      toast.error("Устгахад алдаа гарлаа!", { autoClose: 3000 });
      return rejectWithValue(error.response || error.message);
    }
  }
);
